module.exports = __webpack_public_path__ + "img/acw-white.420ce34d.png";